import React, { memo, useEffect } from "react";
import { Tabs, TabList, TabPanels, Tab, TabPanel, Highlight, Box, Text, Flex, Heading, ListItem, Link as MyLink, ListIcon, List, Divider } from '@chakra-ui/react'
import "./common.css";
import Image from "../assets/img/About/Image.gif";
import VanillaTilt from 'vanilla-tilt';
import { Link } from "react-scroll";
import AOS from 'aos'
import 'aos/dist/aos.css'
import { HiCheckCircle } from "react-icons/hi"
import { useContext } from "react";
import { ThemeContext } from "../context/ThemeContext";
const bs = {
  border: "1px solid #35B4E2",
  borderRadius: "7%",
  margin: "auto"
}

const options = {
  scale: 1.1,
  speed: 1000,
  max: 30
};

const About = () => {
  const { Theme } = useContext(ThemeContext)
  useEffect(() => {
    AOS.init();
  }, [])
  return (
    <section className={`${Theme === "dark" && "darkBackground1"} section bg-transition pt-10`} id="about" >
      <Tilt options={options} Theme={Theme} />
      <Tabs variant='unstyled' align="center"  >
        <TabList>
          <Tab _selected={{ color: 'white', bg: `${Theme === "dark" ? "#F2AA4CFF" : "red.400"}` }} bg={Theme === "dark" ? "#61605e" : "#fff"} color={Theme === "dark" ? "#fff" : "#000"} borderRadius={"7px"} ml={["3", "3", "5", "6", "7"]} className='boxShadow' _hover={{ bg: `${Theme === "dark" ? "#F2AA4CFF" : "#F08E8B"}`, color: 'white' }} >About</Tab>
          <Tab _selected={{ color: 'white', bg: `${Theme === "dark" ? "#F2AA4CFF" : "red.400"}` }} bg={Theme === "dark" ? "#61605e" : "#fff"} color={Theme === "dark" ? "#fff" : "#000"} borderRadius={"7px"} ml={["3", "3", "5", "6", "7"]} className='boxShadow' _hover={{ bg: `${Theme === "dark" ? "#F2AA4CFF" : "#F08E8B"}`, color: 'white' }}>Experience</Tab>
        </TabList>
        <div className="container mx-auto mt-20" data-aos="fade-up" >
          <div className="flex flex-col xl:flex-row gap-24">
            <img style={bs} className={`lg:hidden border-4 h-full w-[370px] ${Theme === "dark" ? "border-[#F2AA4CFF]" : ' border-red-400'}`} src={'https://i.ibb.co/CvgCGgC/Picsart-23-01-06-19-52-24-727.png'} alt={'Monu'} />
            <img
              className={` hidden lg:block object-cover h-full w-[450px] border-4 md:mx-auto lg:mx-auto rounded-2xl coderImage ${Theme === "dark" ? "border-[#F2AA4CFF]" : ' border-red-400'}`}
              src={Image}
              alt="Monu"
              data-aos="zoom-in"
              data-aos-delay="4000"
            />

            <TabPanels>
              {/* About Panel */}
              <TabPanel>
                <div data-aos="zoom-in"
                  data-aos-delay="100" className="flex flex-col items-center text-center lg:items-start lg:text-left">
                  <div className="flex flex-col">
                    <Text mb={"3"} color={Theme === "dark" ? "#ffffff" : "black"} className={`papa`}><span>Full-Stack</span> Web <span>Developer</span></Text>
                    <hr className="mb-8 opacity-5" />
                    <Text mb={"10"} fontSize={["15", "15", "16", "18", "18"]} fontWeight={"400"} color={Theme === "dark" ? "#ffffff" : "#383736"}>
                      Hello! My name is Monu Yadav & I enjoy creating things that live on the internet. I'm a passionate Developer, with strong administrative & communication skills, good attention to detail & the ability to write efficient code.<br />
                      <Divider my="3" borderColor={"gray.400"} />
                      I'm open to Job opportunities. If you think my skills are relevant to your job requirements then do contact me.
                    </Text>
                  </div>
                  <Link
                    activeClass="active"
                    spy={true}
                    smooth={true}
                    duration={500}
                    offset={-70}
                    className="transition-all duration-300"
                    to={"contact"}
                  >
                    <button className={`relative inline-flex items-center justify-start px-6 py-3 overflow-hidden font-medium transition-all ${Theme === "dark" ? "bg-[#F2AA4CFF]" : "bg-red-500"} rounded-xl group`}>
                      <span className={`absolute top-0 right-0 inline-block w-4 h-4 transition-all duration-500 ease-in-out ${Theme === "dark" ? "bg-[#ba8f32]" : "bg-red-900"} rounded group-hover:-mr-4 group-hover:-mt-4`}>
                        <span className="absolute top-0 right-0 w-5 h-5 rotate-45 translate-x-1/2 -translate-y-1/2 bg-white"></span>
                      </span>
                      <span className={`absolute bottom-0 left-0 w-full h-full transition-all duration-500 ease-in-out delay-200 -translate-x-full translate-y-full ${Theme === "dark" ? "bg-[#ba8f32]" : "bg-red-400"} rounded-2xl group-hover:mb-12 group-hover:translate-x-0`}></span>
                      <span className={`relative w-full text-left ${Theme === "dark" ? "text-black-400" : "text-white"} transition-colors duration-200 ease-in-out group-hover:${Theme === "dark" ? "text-black-400" : "text-white"}`}>Contact me</span>
                    </button>
                  </Link>
                </div>


              </TabPanel>
              {/* Experience Panel */}
              <TabPanel>
                <Flex data-aos="zoom-in"
                  data-aos-delay="4000" borderBottom={Theme !== 'dark' ? "8px solid #f05151" : "8px solid #F2AA4CFF"} borderTop={Theme !== 'dark' ? "8px solid #f05151" : "8px solid #F2AA4CFF"} flexDir={"column"} className="boxShadow soft2" w={["100%", "100%", "600px", "600px", "500px"]} bg={Theme === "dark" ? "#7a7976" : "#fff"} py="7" borderRadius={"10"} textAlign={[null, null, null, "left", null]}  >
                  {/* Heading */}
                  <Flex flexDir={["column", "column", "row", "row", "row"]} w="90%" margin={"auto"} justifyContent={"space-between"} >
                    <Flex flexDir={"column"}  >
                      <Heading fontSize={"19"} color={Theme === "dark" ? "#F2AA4CFF" : "#555755"} textAlign={"left"} >Success Webtech</Heading>
                      <Text color={Theme === "dark" ? "blackAlpha.700" : "#555755"} as='i' textAlign={"left"} fontWeight={"450"} >Full Stack Developer</Text>
                    </Flex>
                    <Flex flexDir={"column"} mt={["5", "5", 0, 0, 0]}   >
                      <Text color={Theme === "dark" ? "blackAlpha.700" : "#555755"} textAlign={["left", "left", null, null, null]} fontSize={[13, 13, 15, 15, 15]} fontWeight={"500"} >Noida, Uttar Pradesh</Text>
                      <Text color={Theme === "dark" ? "blackAlpha.700" : "#555755"} textAlign={["left", "left", null, null, null]} fontSize={[13, 13, 15, 15, 15]} fontWeight={"500"} as='i'>Nov 2022 - Jan 2023 </Text>
                    </Flex>
                  </Flex>
                  {/* Desciption of experience */}
                  <List spacing={3} w="90%" m="auto" mt="5" >
                    <ListItem color={Theme === "dark" ? "#ffffff" : "#717572"} textAlign={"left"} fontSize={[12, 12, 13, 14, 14]} fontWeight={"500"}>
                      <ListIcon as={HiCheckCircle} color={Theme === "dark" ? "#F2AA4CFF" : "red.400"} />
                      Developed and maintained web applications using languages such as HTML, CSS, JavaScript and ReactJS
                    </ListItem>
                    <ListItem color={Theme === "dark" ? "#ffffff" : "#717572"} textAlign={"left"} fontSize={[12, 12, 13, 14, 14]} fontWeight={"500"} >
                      <ListIcon as={HiCheckCircle} color={Theme === "dark" ? "#F2AA4CFF" : "red.400"} />
                      This opportunity has allowed me to apply my knowledge and learn from experienced professionals in the industry
                    </ListItem>
                    <ListItem color={Theme === "dark" ? "#ffffff" : "#717572"} textAlign={"left"} fontSize={[12, 12, 13, 14, 14]} fontWeight={"500"}>
                      <ListIcon as={HiCheckCircle} color={Theme === "dark" ? "#F2AA4CFF" : "red.400"} />
                      Implemented responsive designs
                    </ListItem>
                    <ListItem color={Theme === "dark" ? "#ffffff" : "#717572"} textAlign={"left"} fontSize={[12, 12, 13, 14, 14]} fontWeight={"500"}>
                      <ListIcon as={HiCheckCircle} color={Theme === "dark" ? "#F2AA4CFF" : "red.400"} />
                      Developed successwebtech website <MyLink isExternal={true} color={Theme === "dark" ? "#F2AA4CFF" : "red.400"} href='https://www.successwebtech.com/'>
                        www.successwebtech.com
                      </MyLink>
                    </ListItem>
                  </List>
                </Flex>
              </TabPanel>
            </TabPanels>


          </div>
          {/* Education */}

          <Box w='100%' mt="50px" mb="-50px">
            <Tilt2 options={options} Theme={Theme} />
            {/* stick */}
            <Box display={["block", "block", "none", "none", "none"]} >
              <Box data-aos="flip-up" className={`${Theme === 'dark' ? 'dsfbui' : 'dsfbu3'} bg-transition`} textAlign={"left"} borderRadius="10px" w="max-content" py="20px" px={"20px"} >
                <a target="_blank" href="http://www.ignou.ac.in/" ><Text color={`${Theme === "dark" ? "#F2AA4CFF" : "#eb584d"}`} lineHeight={"16px"} mb="2px" fontSize={["14px", "14px", "14px", "16px", "16px"]} fontWeight={"500"} >
                  IGNOU, Delhi
                </Text></a>
                <Text color={`${Theme !== "dark" ? "#000000" : "#ffffff"}`} mb="10px" fontSize={["12px", "12px", "12px", "14px", "14px"]} fontWeight={"500"} >
                  Bachelor of Computer Applications
                </Text>
                <Text color={`${Theme === "dark" ? "#F2AA4CFF" : "#eb584d"}`} my="10px" fontSize={["12px", "12px", "12px", "14px", "14px"]} fontWeight={"400"} >
                  Feb, 2023 - Pursuing...
                </Text>
              </Box>
              <Box w="10px" height={"200px"} borderRadius='10px' className={`${Theme === 'dark' ? 'darkstick' : 'lightstick'}`}>

              </Box>
              {/* Masai School */}
              <Box data-aos="flip-up" className={`${Theme === 'dark' ? 'dsfbui1' : 'dsfbui2'} bg-transition`} textAlign={"left"} borderRadius="10px" w="max-content" py="20px" px={"20px"} >
                <a target="_blank" href="https://masaischool.com/" ><Text color={`${Theme === "dark" ? "#F2AA4CFF" : "#eb584d"}`} lineHeight={"16px"} mb="2px" fontSize={["14px", "14px", "14px", "16px", "16px"]} fontWeight={"500"} >
                  Masai School, Bengaluru
                </Text></a>
                <Text color={`${Theme !== "dark" ? "#000000" : "#ffffff"}`} mb="10px" fontSize={["12px", "12px", "12px", "14px", "14px"]} fontWeight={"500"} >
                  Full Stack Web Development - MERN
                </Text>
                <Text color={`${Theme !== "dark" ? "#000000" : "#ffffff"}`} mb="10px" fontSize={["12px", "12px", "12px", "14px", "14px"]} fontWeight={"400"} >
                  2160 hours of practical learning
                </Text>
                <Text color={`${Theme === "dark" ? "#F2AA4CFF" : "#eb584d"}`} my="10px" fontSize={["12px", "12px", "12px", "14px", "14px"]} fontWeight={"400"} >
                  Feb, 2022 - Feb, 2023
                </Text>
              </Box>
              <Box w="10px" height={"200px"} borderRadius='10px' className={`${Theme === 'dark' ? 'darkstick' : 'lightstick'}`}>

              </Box>
              {/* High School */}
              <Box data-aos="flip-up" className={`${Theme === 'dark' ? 'dsfbui' : 'dsfbu3'} bg-transition`} textAlign={"left"} borderRadius="10px" w="max-content" py="20px" px={"20px"} mb="100px" >
                <Text color={`${Theme === "dark" ? "#F2AA4CFF" : "#eb584d"}`} lineHeight={"16px"} mb="2px" fontSize={["14px", "14px", "14px", "16px", "16px"]} fontWeight={"500"} >
                  G B S S School, Delhi
                </Text>
                <Text color={`${Theme !== "dark" ? "#000000" : "#ffffff"}`} mb="10px" fontSize={["12px", "12px", "12px", "14px", "14px"]} fontWeight={"500"} >
                  Higher Education (11<sup>тн</sup> -12<sup>тн</sup>)
                </Text>
                <Text color={`${Theme === "dark" ? "#F2AA4CFF" : "#eb584d"}`} my="10px" fontSize={["12px", "12px", "12px", "14px", "14px"]} fontWeight={"400"} >
                  Apr, 2019 - Apr, 2021
                </Text>
              </Box>
            </Box>
            <Box pos="relative" display={["none", 'none', "block", 'block', 'block']} w="10px" height={"1100px"} borderRadius='10px' mt="50px" mb="20px" className={`${Theme === 'dark' ? 'darkstick' : 'lightstick'}`} >
              {/* Bca Pursuing */}
              <Box data-aos="fade-up-right" className={`${Theme === 'dark' ? 'dsfbui' : 'dsfbu3'} bg-transition`} textAlign={"right"} position="absolute" borderRadius="10px" w="max-content" top="90px" left={["-230px", "-230px", "-280px", "-330px", "-330px"]} py="20px" px={["5px", "5px", "20px", "30px", "30px"]} >
                <a target="_blank" href="http://www.ignou.ac.in/" ><Text color={`${Theme === "dark" ? "#F2AA4CFF" : "#eb584d"}`} lineHeight={"16px"} mb="2px" fontSize={["14px", "14px", "14px", "16px", "16px"]} fontWeight={"500"} >
                  IGNOU, Delhi
                </Text></a>
                <Text color={`${Theme !== "dark" ? "#000000" : "#ffffff"}`} mb="10px" fontSize={["12px", "12px", "12px", "14px", "14px"]} fontWeight={"500"} >
                  Bachelor of Computer Applications
                </Text>
                <Text color={`${Theme === "dark" ? "#F2AA4CFF" : "#eb584d"}`} my="10px" fontSize={["12px", "12px", "12px", "14px", "14px"]} fontWeight={"400"} >
                  Feb, 2023 - Pursuing...
                </Text>
              </Box>
              {/* Masai School */}
              <Box data-aos="fade-up-left" className={`${Theme === 'dark' ? 'dsfbui1' : 'dsfbui2'} bg-transition`} textAlign={"left"} position="absolute" borderRadius="10px" w="max-content" top="440px" right={["-240px", "-240px", "-290px", "-340px", "-340px"]} py="20px" px={["5px", "5px", "20px", "30px", "30px"]} >
                <a target="_blank" href="https://masaischool.com/" ><Text color={`${Theme === "dark" ? "#F2AA4CFF" : "#eb584d"}`} lineHeight={"16px"} mb="2px" fontSize={["14px", "14px", "14px", "16px", "16px"]} fontWeight={"500"} >
                  Masai School, Bengaluru
                </Text></a>
                <Text color={`${Theme !== "dark" ? "#000000" : "#ffffff"}`} mb="10px" fontSize={["12px", "12px", "12px", "14px", "14px"]} fontWeight={"500"} >
                  Full Stack Web Development - MERN
                </Text>
                <Text color={`${Theme !== "dark" ? "#000000" : "#ffffff"}`} mb="10px" fontSize={["12px", "12px", "12px", "14px", "14px"]} fontWeight={"400"} >
                  2160 hours of practical learning
                </Text>
                <Text color={`${Theme === "dark" ? "#F2AA4CFF" : "#eb584d"}`} my="10px" fontSize={["12px", "12px", "12px", "14px", "14px"]} fontWeight={"400"} >
                  Feb, 2022 - Feb, 2023
                </Text>
              </Box>
              {/* High School */}
              <Box data-aos="fade-up-right" className={`${Theme === 'dark' ? 'dsfbui' : 'dsfbu3'} bg-transition`} textAlign={"right"} position="absolute" borderRadius="10px" w="max-content" bottom="126px" left={["-295px", "-265px", "-255px", "-295px", "-295px"]} py="20px" px={["5px", "5px", "20px", "30px", "30px"]} >
                <Text color={`${Theme === "dark" ? "#F2AA4CFF" : "#eb584d"}`} lineHeight={"16px"} mb="2px" fontSize={["14px", "14px", "14px", "16px", "16px"]} fontWeight={"500"} >
                  G B S S School, Delhi
                </Text>
                <Text color={`${Theme !== "dark" ? "#000000" : "#ffffff"}`} mb="10px" fontSize={["12px", "12px", "12px", "14px", "14px"]} fontWeight={"500"} >
                (11<sup>тн</sup> -12<sup>тн</sup>) Higher Education
                </Text>
                <Text color={`${Theme === "dark" ? "#F2AA4CFF" : "#eb584d"}`} my="10px" fontSize={["12px", "12px", "12px", "14px", "14px"]} fontWeight={"400"} >
                  Apr, 2019 - Apr, 2021
                </Text>
              </Box>
              <Box data-aos="fade-up" borderRadius="50%" pos="absolute" top="90px" left="-3px" width="16px" h="16px" bg={`${Theme === "dark" ? "#F2AA4CFF" : "red.400"}`} >
              </Box>
              <Box data-aos="fade-up" borderRadius="50%" pos="absolute" top="440px" left="-3px" width="16px" h="16px" bg={`${Theme === "dark" ? "#F2AA4CFF" : "red.400"}`} >
              </Box>
              <Box data-aos="fade-up" borderRadius="50%" pos="absolute" bottom="230px" left="-3px" width="16px" h="16px" bg={`${Theme === "dark" ? "#F2AA4CFF" : "red.400"}`} >
              </Box>
            </Box>
          </Box>
        </div>
      </Tabs>
    </section>
  );
};


function Tilt2(props) {
  const { options, Theme } = props;
  const tilt = React.useRef(null);

  useEffect(() => {
    VanillaTilt.init(tilt.current, options);
  }, [options]);

  return <Box w={"50%"} ref={tilt} m="auto" data-aos="zoom-out-down" >
    <Text color={Theme === "dark" ? "#fff" : "#000"} fontWeight='bold' mb="5" mt="15" fontSize={["20", "20", "30", "40", "40"]} textAlign={"center"} >
      <Highlight
        query={'Education'}
        styles={{ color: `${Theme === "dark" ? "#F2AA4CFF" : "red.400"}` }}
      >
        My Education
      </Highlight>
    </Text>
  </Box>
}
function Tilt(props) {
  const { options, Theme } = props;
  const tilt = React.useRef(null);

  useEffect(() => {
    VanillaTilt.init(tilt.current, options);
  }, [options]);

  return <Box w={"50%"} ref={tilt} m="auto" data-aos="zoom-out-down" >
    <Text color={Theme === "dark" ? "#fff" : "#000"} fontWeight='bold' mb="5" mt="15" fontSize={["20", "20", "30", "40", "40"]} textAlign={"center"} >
      <Highlight
        query={['About', 'Experience']}
        styles={{ color: `${Theme === "dark" ? "#F2AA4CFF" : "red.400"}` }}
      >
        All About Me  & My Experience
      </Highlight>
    </Text>
  </Box>
}
export default memo(About);
